import { useMutation } from '@tanstack/react-query';
import { useGroupApi } from 'services';

export const useAcceptInvitation = () => {
  const { acceptPendingGroupJoinRequest } = useGroupApi();

  return useMutation({ mutationFn: acceptPendingGroupJoinRequest });
};
